// This is a generated file. Any changes made directly in this file will be overwritten.
import * as React from 'react';
import { createSvgIcon } from '@bb-ui/react-library/dist/internal/icons';

export const Faster = createSvgIcon(
  { LeftToRight: <React.Fragment><path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M22.9569 12.9816A11.141 11.141 0 0023.0001 12c0-6.0751-4.9248-11-11-11-6.0751 0-11 4.9249-11 11s4.9249 11 11 11c1.0383 0 2.043-.1439 2.9952-.4127" /><path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M11.3816 12.4532l9.6549 8.1696-8.1695-9.6549-1.4854 1.4853z" /></React.Fragment>, },
  'default'
);
